import { render, staticRenderFns } from "./SelectedFiduciary.vue?vue&type=template&id=ef5fe06c&"
import script from "./SelectedFiduciary.vue?vue&type=script&lang=js&"
export * from "./SelectedFiduciary.vue?vue&type=script&lang=js&"
import style0 from "./SelectedFiduciary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports